module.exports = __webpack_public_path__ + "img/online.12f60b43.svg";